@if (!(isRefreshingToken$ | async)) {
  <div class="app-wrapper">
    @if (showHeader) {
      <app-header
        class="app-header"
        (toggleSideBarForMe)="onSidebarToggle($event)">
      </app-header>
    }
    <div class="app-container" [class.no-header]="!showHeader">
      @if (showSidebar) {
        <app-sidebar
          [expanded]="sidebarExpanded"
          class="fixed-sidebar"
          (sidebarToggled)="onSidebarToggle($event)">
        </app-sidebar>
      }
      <main class="main-content"
        [class.with-sidebar]="showHeader && showSidebar"
        [class.collapsed]="!sidebarExpanded"
        [class.full-page]="!showHeader">
        <!--<app-tab-navigation *ngIf="showHeader"></app-tab-navigation>-->
        <div class="page-content">
          <router-outlet></router-outlet>
        </div>
      </main>
    </div>
    <!-- Interactive Guide Drawer Navigation -->
    <app-guide-drawer></app-guide-drawer>
    <!-- Custom Support Widget -->
    <app-support-widget></app-support-widget>
    <!-- <app-footer *ngIf="showFooter"></app-footer> -->
  </div>
} @else {
  <div id="spinner" class="spinner-wrapper">
    <mat-progress-spinner
      class="mat-spinner-color"
      mode="indeterminate"
      diameter="50">
    </mat-progress-spinner>
  </div>
}

<!-- Optional: Show loading message or spinner -->
